import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-unsaved-changes-modal',
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrls: ['./unsaved-changes-modal.component.scss']
})
export class UnsavedChangesModalComponent {
  @Input() dialogVisible: boolean = false;
  @Input() confirmationMessage: string = 'You have unsaved changes. What would you like to do?';
  @Input() confirmationHeader: string = 'Unsaved Changes';
  @Input() isSaving: boolean = false; // To show loading state during save
  
  @Output() saveAndContinue = new EventEmitter<void>();
  @Output() discardAndContinue = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() hide = new EventEmitter<void>();

  constructor() { }

  onSaveAndContinue() {
    this.saveAndContinue.emit();
  }

  onDiscardAndContinue() {
    this.discardAndContinue.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  onDialogHide() {
    this.hide.emit();
    this.dialogVisible = false;
  }
}

